import { Button } from "react-admin"
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { downloadReport } from "../utils";

const BackupButton = () => {
    const handleBackupButton = () => {
        const isBackup = true;
        downloadReport(isBackup);
    };

    return (
        <Button label="Backup" onClick={handleBackupButton}>
            <CloudDownloadIcon />
        </Button>
    )
}

export default BackupButton
